import React from 'react';
import { XIcon } from 'lucide-react';
import { painClaim, painIntro, painPoints, whyTraditionalFails } from '../data/content';
export function PainPoints() {
  return <section className="bg-night-panel" data-id="element-186" data-mp="2lp58b04xzixw">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-187" data-mp="26xeftbjvgl3v">
        <div className="mx-auto max-w-3xl text-center" data-id="element-188" data-mp="2bxiucw17z5rg">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-189" data-mp="2bvy3bge464yc">
            ¿Cuántas veces más vas a sentirte perdido leyendo la Biblia?
          </h2>
          <p className="mt-5 font-sans text-base leading-relaxed text-parchment/70" data-id="element-190" data-mp="220o2gvzgc3m5">
            {painIntro}
          </p>
          <p className="mt-6 font-display text-2xl font-semibold text-gold-soft" data-id="element-191" data-mp="1o1wm12x4a5uu">
            {painClaim}
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-192" data-mp="3idbi01gq11j1">
          {painPoints.map(point => <li key={point} className="flex gap-3 rounded-xl border border-rust/25 bg-rust/10 px-5 py-4" data-id="element-193" data-mp="3ncxuu9sn0frb">
              <XIcon className="mt-0.5 h-5 w-5 flex-none text-rust-soft" aria-hidden="true" data-id="element-194" data-mp="1yykdfd6qx80p" />
              <span className="font-sans text-base font-medium leading-relaxed text-parchment/85" data-id="element-195" data-mp="27ti92s1a2yvq">
                {point}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-16 max-w-3xl" data-id="element-196" data-mp="1g1j6vnxjmzun">
          <h3 className="text-center font-display text-2xl font-semibold tracking-tight text-parchment" data-id="element-197" data-mp="1g2cfyvjz61fy">
            Por qué los métodos tradicionales no funcionan
          </h3>
          <div className="mt-8 grid gap-6 sm:grid-cols-2" data-id="element-198" data-mp="1p3k1ed1e77sm">
            {whyTraditionalFails.map(item => <div key={item.title} className="rounded-2xl border border-night-line bg-night p-6" data-id="element-199" data-mp="1k2moofz5j5yi">
                <h4 className="font-sans text-base font-semibold text-gold-soft" data-id="element-200" data-mp="2vil0grlps63f">
                  {item.title}
                </h4>
                <p className="mt-2 font-sans text-sm leading-relaxed text-parchment/70" data-id="element-201" data-mp="1t43mt3mq8gxc">
                  {item.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}